import { t } from 'i18next';
import n2words from 'n2words';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MailIcon from '@mui/icons-material/Mail';
import { showDate2 } from 'src/constants';

const Invoice = ({ data }) => {
  const { language } = useSelector((state) => state.auth);
  const { i18n } = useTranslation();

  // Ensure i18n language matches Redux language for PDF generation
  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language, i18n]);

  const minRows = 6;
  const subOrders = data.subOrder;
  const totalSubOrders = subOrders.length;
  const totalRows = Math.max(minRows, totalSubOrders);

  const rowsToRender = [
    ...subOrders.map((subOrder) => ({
      ...subOrder,
      ref: subOrder.subOrderNumber,
    })),
    ...Array(totalRows - totalSubOrders).fill({}),
  ];

  return (
    <div
      id="invoice"
      style={{
        width: '210mm',
        height: '297mm',
        display: 'none',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <style>
        {`
          h4 {
            margin: 0;
          }
        `}
      </style>
      <section
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ width: '80mm' }}>
          <img src="/header.jpg" alt="" style={{ height: '100%', width: '100%' }} />
        </div>
        <div
          style={{
            width: '130mm',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              width: '65mm',
              textAlign: 'right',
              color: '#898888',
              fontSize: '3.75mm',
            }}
          >
            <h4 style={{ fontWeight: 600 }}>RCCM: CD/KNM/RCM/19-B-00291</h4>
            <h4 style={{ fontWeight: 600 }}>Id. Nat: 01-490-N499993T</h4>
            <h4 style={{ fontWeight: 600 }}>№Impôt A1915112Y</h4>
          </div>
          <div style={{ width: '40mm', height: 'max-content' }}>
            <img src="/logo.jpeg" style={{ width: '100%', height: '100%' }} alt="logo" />
          </div>
        </div>
      </section>
      <section style={{ width: '190mm', display: 'flex', justifyContent: 'center' }}>
        <div
          style={{
            border: '0.5mm solid black',
            padding: '0 22mm 2.5mm 22mm',
            fontWeight: 900,
            fontSize: '3.5mm',
          }}
        >
          {t('invoice.bill')} N° {data?.orderNumber}
        </div>
      </section>

      <section
        style={{
          width: '190mm',
          textAlign: 'start',
          marginTop: '5mm',
          fontSize: '4.2mm',
          paddingLeft: '8mm',
        }}
      >
        <h4>Date: {showDate2(data?.createdAt)}</h4>
      </section>

      <section style={{ width: '190mm', display: 'flex', justifyContent: 'flex-end', paddingRight: '8mm' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            backgroundColor: '#eaeaea',
            width: '95mm',
            height: '15mm',
            fontSize: '11px',
            paddingLeft: '2mm',
            paddingBottom: '2mm',
            fontWeight: 900,
          }}
        >
          <p>Client: {data?.customerId.firstName + ' ' + data?.customerId.lastName}</p>
          <p>Tel: {data?.customerId.phoneNumber}</p>
        </div>
      </section>

      <table
        style={{
          width: '174mm',
          borderCollapse: 'collapse',
          marginTop: '5mm',
          paddingLeft: '8mm',
          paddingRight: '8mm',
        }}
      >
        <thead>
          <tr>
            <th style={{ border: '0.5mm solid black', borderRight: 'none', padding: '0 1.5mm 4mm 1.5mm' }}>
              {t('invoice.sNo')}
            </th>
            <th style={{ border: '0.5mm solid black', borderRight: 'none', padding: '0 1.5mm 4mm 1.5mm' }}>
              {t('invoice.designation')}
            </th>
            <th style={{ border: '0.5mm solid black', borderRight: 'none', padding: '0 1.5mm 4mm 1.5mm' }}>
              {t('invoice.quantity')}
            </th>
            <th style={{ border: '0.5mm solid black', borderRight: 'none', padding: '0 1.5mm 4mm 1.5mm' }}>
              {t('invoice.price')} {t('invoice.unit')}
            </th>
            <th style={{ border: '0.5mm solid black', padding: '0 1.5mm 4mm 1.5mm' }}>{t('invoice.price')} Total</th>
          </tr>
        </thead>
        <tbody>
          {rowsToRender.map((row, index) => (
            <tr key={index} style={{ height: '8mm' }}>
              <td
                style={{
                  borderLeft: '0.5mm solid black',
                  borderBottom: '0.5mm solid black',
                  textAlign: 'center',
                  paddingBottom: '4mm',
                }}
              >
                {row.subOrderNumber || ''}
              </td>
              <td
                style={{
                  borderLeft: '0.5mm solid black',
                  borderBottom: '0.5mm solid black',
                  textAlign: 'center',
                  paddingBottom: '4mm',
                }}
              >
                {row.dosage ? t('invoice.dosage') + row.dosage : ''}
              </td>
              <td
                style={{
                  borderLeft: '0.5mm solid black',
                  borderBottom: '0.5mm solid black',
                  textAlign: 'center',
                  paddingBottom: '4mm',
                }}
              >
                {row.volumeOfConcrete ? `${row.volumeOfConcrete} m³` : ''}
              </td>
              <td
                style={{
                  borderLeft: '0.5mm solid black',
                  borderBottom: '0.5mm solid black',
                  textAlign: 'center',
                  paddingBottom: '4mm',
                }}
              >
                {row.perCubicMeterConcretePrice || ''}
              </td>
              <td style={{ border: '0.5mm solid black', borderTop: 'none', textAlign: 'center', paddingBottom: '4mm' }}>
                {row.amount || ''}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <section
        style={{
          width: '174mm',
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: '6mm',
          fontSize: '4.5mm',
          maxHeight: '35px',
        }}
      >
        <div
          style={{
            width: '75mm',
            backgroundColor: '#eaeaea',
            display: 'flex',
            alignItems: 'center',
            padding: '0 2mm 4mm 2mm',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <h4>THT:</h4>
            <h4>
              {data.totalAmount != null && data.taxRate != null
                ? (Number(data.totalAmount) / (1 + Number(data.taxRate) / 100)).toFixed(2)
                : 0}{' '}
              USD
            </h4>
          </div>
        </div>
        <div
          style={{
            width: '75mm',
            backgroundColor: '#eaeaea',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingLeft: '2mm',
          }}
        >
          <div style={{ paddingBottom: '4mm' }}>
            <h4>{t('invoice.netPay')}:</h4>
          </div>
          <h4
            style={{
              border: '0.5mm solid black',
              width: '30mm',
              paddingBottom: '4mm',
              background: 'white',
              textAlign: 'center',
            }}
          >
            {data.totalAmount || 0} USD
          </h4>
        </div>
      </section>

      <section style={{ width: '174mm', paddingRight: '8mm', maxHeight: '35px' }}>
        {data.totalAmount && (
          <h3 style={{ fontSize: '12px' }}>
            {t('invoice.tagline')} {n2words(data.totalAmount || 0, { lang: language === 'ENGLISH' ? 'en' : 'fr' })} US
            dollars.
          </h3>
        )}
      </section>

      <section
        style={{
          width: '174mm',
          fontSize: '10px',
          color: '#333',
        }}
      >
        <strong style={{ textDecoration: 'underline', display: 'block' }}>{t('invoice.stipulationsTitle')}</strong>
        <br />
        <strong> {t('invoice.stipulationsIntro')}</strong>
        <div style={{ margin: '2px 0 0 0', padding: 0 }}>
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ minWidth: '1.5em', fontWeight: 600 }}>1.</span>
            <span>{t('invoice.condition1')}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ minWidth: '1.5em', fontWeight: 600 }}>2.</span>
            <span>{t('invoice.condition2')}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ minWidth: '1.5em', fontWeight: 600 }}>3.</span>
            <span>{t('invoice.condition3')}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ minWidth: '1.5em', fontWeight: 600 }}>4.</span>
            <span>{t('invoice.condition4')}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ minWidth: '1.5em', fontWeight: 600 }}>5.</span>
            <span>{t('invoice.condition5')}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ minWidth: '1.5em', fontWeight: 600 }}>6.</span>
            <span>{t('invoice.condition6')}</span>
          </div>
        </div>
      </section>

      {/* create section */}
      <div
        style={{
          width: '174mm',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          fontSize: '12px',
          fontWeight: 900,
          marginTop: '20px',
        }}
      >
        {/* Left: Client info */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', minWidth: '60mm' }}>
          <span>{t('invoice.clientName')}</span>
          <span>{t('invoice.readAndApproved')}</span>
        </div>
        {/* Right: Stamp and Billing Service */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            minWidth: '125px',
            position: 'relative',
            justifyContent: 'center',
            height: '100px', // adjust as needed
          }}
        >
          {data.paymentMethod && (
            <img
              alt="stamp"
              src="/stamp.png"
              style={{
                width: '120px',
                position: 'absolute',
                top: '-15px', // adjust as needed
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 2,
                opacity: 0.8, // optional, for a real stamp effect
              }}
            />
          )}
          <span style={{ marginTop: '0.5rem', zIndex: 1, position: 'relative' }}>{t('invoice.billingService')}</span>
        </div>
      </div>
      {/* footer section */}
      <div
        style={{
          display: 'flex',
          width: '185mm',
          alignItems: 'flex-end',
          fontWeight: 500,
          marginTop: '15px',
          marginBottom: '32px',
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1.75fr 2fr 2fr',
          }}
        >
          <div style={{ display: 'flex' }}>
            <PhoneIcon />
            <p style={{ marginTop: '-0.6rem' }}>+243 848 013 975</p>
          </div>
          <div style={{ display: 'flex' }}>
            <MailIcon /> <p style={{ marginTop: '-0.6rem' }}>centralebeton@jmc-rdc.com</p>
          </div>
          <div style={{ display: 'flex' }}>
            <LocationOnIcon />{' '}
            <p style={{ marginTop: '-0.6rem' }}>
              Port onatra, référence entrée ront point forescom commune de la gombe
            </p>
          </div>
        </div>
      </div>
      {/* End padded content */}
      {/* Blue strip at the bottom */}
      <div
        style={{
          width: '100%',
          height: '6mm',
          background: '#0074D9', // blue color
        }}
      />
    </div>
  );
};

export default Invoice;
